










import { Component, Watch, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import MainNavBar from '@/modules/shared/components/main-navbar.component.vue';

@Component({
  computed: {
    ...mapGetters ({
      scrollTop: 'scrollTop',
      mainNavbarIsOpen: 'isOpenNavbar',
    }),
  },
  components: {
    MainNavBar,
  },
})
export default class AppLayout extends Vue {
  private mainNavbarIsOpen!: boolean;
}
